import React, { useState } from 'react';
import { AiOutlineHeart, AiFillHeart } from 'react-icons/ai';
import BookingPopup from '../../components/BookingPopup/BookingPopup';
import '../../components/Styles/ClientPage.css'; // Import the CSS file
import image1 from '../../images/Resort.png';
const ImageGallery = ({ venueDetails }) => {
  const productDetails = venueDetails?.responseContent?.productDetails || [];
  const [favorites, setFavorites] = useState({});
  const [notifications, setNotifications] = useState({});
  const [showPopup, setShowPopup] = useState(false);
  const [selectedProductId, setSelectedProductId] = useState('');
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [selectedSlot, setSelectedSlot] = useState('');
  const [numPeople, setNumPeople] = useState(1);
  const [totalAmount, setTotalAmount] = useState(0);

  const toggleFavorite = (index) => {
    const newFavorites = { ...favorites, [index]: !favorites[index] };
    setFavorites(newFavorites);
    setNotifications((prev) => ({
      ...prev,
      [index]: newFavorites[index] ? 'Added to favorites' : null,
    }));

    setTimeout(() => {
      setNotifications((prev) => ({
        ...prev,
        [index]: null,
      }));
    }, 2000);
  };

  const handleBookSlot = (e, productId) => {
    e.stopPropagation();
    setSelectedProductId(productId);
    setShowPopup(true);
  };

  const handleClosePopup = () => {
    setShowPopup(false);
  };

  const handleSlotSelection = (slot) => {
    setSelectedSlot(slot);
    setTotalAmount(slot.price * numPeople);
  };

  const handleBooking = () => {
    setShowPopup(false);
  };

  return (
    <div className="image-gallery-container">
      <h2 className="image-gallery-header">Available Spots</h2>
      <div className="image-gallery-divider"></div>
      <div className="image-gallery-grid">
        {productDetails.map((product, index) => (
          <div key={index} className="product-card">
            <img
              src={product.image || image1}
              alt={`${product.product_name}`}
            />
            <div
              className="favorite-icon"
              onClick={(e) => {
                e.stopPropagation();
                toggleFavorite(index);
              }}
              title={favorites[index] ? '' : 'Add as favorite'}
            >
              {favorites[index] ? (
                <AiFillHeart className="favorite-icon--active" />
              ) : (
                <AiOutlineHeart className="text-black hover:text-red-500" />
              )}
            </div>
            {notifications[index] && (
              <div className="notification">{notifications[index]}</div>
            )}
            <div className="product-info">
              <h3 className="product-title">{product.product_name}</h3>
              <p className="product-price">Price: Starting @ ₹{product.price}</p>
            </div>
            <button
              className="book-slot-button"
              onClick={(e) => handleBookSlot(e, product.product_id)}
            >
              Book Slot
            </button>
          </div>
        ))}
      </div>

      {/* Booking Popup Component */}
      <BookingPopup
        showPopup={showPopup}
        handleClosePopup={handleClosePopup}
        selectedDate={selectedDate}
        setSelectedDate={setSelectedDate}
        selectedSlot={selectedSlot}
        setSelectedSlot={setSelectedSlot}
        numPeople={numPeople}
        setNumPeople={setNumPeople}
        handleSlotSelection={handleSlotSelection}
        totalAmount={totalAmount}
        calculateTotalAmount={(price) => setTotalAmount(price * numPeople)}
        handleBooking={handleBooking}
        productId={selectedProductId}
        venueDetails={venueDetails}
      />
    </div>
  );
};

export default ImageGallery;
